import { Controller } from '@hotwired/stimulus'

// One-shot guest→account reading-progress merge. Rendered on <body> only for
// signed-in users: any positions saved to localStorage while reading as a
// guest are replayed to the server WITH their original timestamps (the server
// ignores entries older than what it already has), then removed locally. When
// there is nothing to merge — the overwhelmingly common case — this is a
// single prefix scan over localStorage and nothing else.
const STORE_PREFIX = 'dh:read:v1:'

export default class extends Controller {
  static values = { url: String }

  connect() {
    let entries
    try {
      entries = []
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.startsWith(STORE_PREFIX)) {
          const entry = JSON.parse(localStorage.getItem(key))
          if (entry && entry.storyId && entry.chapterId) entries.push({ key, entry })
        }
      }
    } catch {
      return
    }
    if (!entries.length) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    entries.forEach(({ key, entry }) => {
      fetch(this.urlValue, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token || '' },
        body: JSON.stringify({
          story_id: entry.storyId,
          chapter_id: entry.chapterId,
          percent: entry.pct || 0,
          block_index: Number.isInteger(entry.block) ? entry.block : null,
          at: entry.at
        })
      })
        .then((response) => {
          // 204 = absorbed (applied, or the server already had fresher data) —
          // either way the local copy is done. Keep it on network/CSRF failure
          // so a later page load retries.
          if (response.ok) localStorage.removeItem(key)
        })
        .catch(() => {})
    })
  }
}
